import { addDaysKey, osloDateKey } from "../misc/osloDate";
import type {
  DealLine,
  Product,
  PublicQuote,
  QuoteLine,
  QuoteStatus,
} from "../types";
import { dealLineTotals, firstYearValue } from "./dealLines";

// Tilbud (analysen v2, pakke E). Speiler quotes i
// 20261025160000_tilbud.sql.

export const QUOTE_STATUSES: QuoteStatus[] = [
  "draft",
  "sent",
  "accepted",
  "declined",
];

// Standard gyldighet for et nytt tilbud.
export const QUOTE_VALID_DAYS = 30;

export const defaultValidUntil = (today = osloDateKey()) =>
  addDaysKey(today, QUOTE_VALID_DAYS);

// Øyeblikksbilde av produktlinjene. Linjer uten egen beskrivelse får
// produktets navn, så kunden aldri ser en tom linje.
export const quoteLinesFromDealLines = (
  lines: DealLine[],
  products: Pick<Product, "id" | "name">[] = [],
): QuoteLine[] =>
  [...lines]
    .sort((a, b) => a.position - b.position)
    .map((line) => ({
      description:
        line.description.trim() ||
        products.find((p) => String(p.id) === String(line.product_id))?.name ||
        "",
      quantity: Number(line.quantity),
      unit_price: Number(line.unit_price),
      interval: line.interval,
    }));

export const quoteTotals = (lines: QuoteLine[]) => {
  const { oneTime, monthly } = dealLineTotals(lines);
  return { oneTime, monthly, firstYear: firstYearValue(oneTime, monthly) };
};

// Bare utkast kan endres. Et sendt tilbud er det kunden har fått.
export const isQuoteEditable = (status: QuoteStatus) => status === "draft";

// Lenken kunden får. Mimin bruker HashRouter, så stien står etter #.
export const quoteLink = (token: string, base = window.location) =>
  `${base.origin}${base.pathname}#/tilbud/${token}`;

// Sendt, men gyldighetsdatoen er passert.
export const isQuoteExpired = (
  quote: Pick<PublicQuote, "status" | "valid_until">,
  today = osloDateKey(),
) =>
  quote.status === "sent" && !!quote.valid_until && quote.valid_until < today;
